document.querySelectorAll( '.js-tabs' ).forEach( element => {
	const tabs = element.querySelectorAll( '.c-tabs__list li' );
	const panels = element.querySelectorAll( '.c-tabs__panel' );
	const hash = window.location.hash;

	tabs.forEach( tab => {
		if ( hash.length ) {
			tab.classList.remove( 'is-active' );

			if ( tab.querySelector( 'a' ).hash === hash ) {
				tab.classList.add( 'is-active' );
			}
		}

		tab.addEventListener( 'click', e => {
			e.preventDefault();
			removeActiveTab();
			addActiveTab( tab );
		} );
	} );

	panels.forEach( panel => {
		if ( hash.length ) {
			panel.classList.remove( 'is-active' );

			if ( '#' + panel.id === hash ) {
				panel.classList.add( 'is-active' );
			}
		}
	} );

	const removeActiveTab = () => {
		tabs.forEach( tab => {
			tab.classList.remove( 'is-active' );
		} );

		panels.forEach( panel => {
			panel.classList.remove( 'is-active' );
		} );
	}

	const addActiveTab = tab => {
		tab.classList.add( 'is-active' );
		const href = tab.querySelector( 'a' ).getAttribute( 'href' );
		const matchingPanel = element.querySelector( href );
		matchingPanel.classList.add( 'is-active' );
	}
} );
